module.exports = "<div style=\"background-image: url({{ options.imageHref }})\" class=\"geo-selector__map-icon\"></div>"